var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-select",
    _vm._g(
      _vm._b(
        {
          staticClass: "select-search-default",
          attrs: {
            filterable: "",
            size: _vm.size,
            remote: "",
            "reserve-keyword": "",
            placeholder: _vm.selectPlaceholder,
            clearable: "",
            "remote-method": _vm.remoteMethod,
            loading: _vm.loading,
          },
          on: { change: _vm.change },
          model: {
            value: _vm.content,
            callback: function ($$v) {
              _vm.content = $$v
            },
            expression: "content",
          },
        },
        "el-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    _vm._l(_vm.merchantList, function (item) {
      return _c("el-option", {
        key: item.merchant_no,
        attrs: {
          label: item.merchant_no + " " + item.merchant_name,
          value: item.merchant_name,
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }